import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import EventDescPartner from "../components/eventDescPartner/EventDescPartner";
import Footer from "../components/Footer";
import Header from "../components/Header";
import {
  applyThemeVarsToElement,
  clearThemeVarsFromElement,
  getEventThemeVars,
} from "../utility/colorUtils";

const EventTicketingPartner = () => {
  const { eventId, partnerId } = useParams();
  const [event, setEvent] = useState();
  const [style, setStyle] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const loadEvent = async () => {
    setIsLoading(true);
    const eventRef = doc(db, "Events", eventId);
    let loadedEvent;

    await getDoc(eventRef)
      .then((snapshot) => {
        const data = {
          id: snapshot.id,
          ...snapshot.data(),
        };
        loadedEvent = data;
      })
      .catch((err) => {
        console.log("Fetch event failed: " + err);
      });

    setStyle(getEventThemeVars(loadedEvent));
    setEvent(loadedEvent);
    setIsLoading(false);
  };

  useEffect(() => {
    if (eventId.length) {
      loadEvent();
    }
  }, [eventId]);

  useEffect(() => {
    if (!event) return undefined;
    applyThemeVarsToElement(document.body, getEventThemeVars(event));
    return () => {
      clearThemeVarsFromElement(document.body);
    };
  }, [event]);

  return (
    <div
      className={`event-ticketing ${event?.darkMode === false ? "light-mode" : ""}`}
      style={style}
    >
      <Header logoUrl={event?.logoUrl} isLoading={isLoading} />
      {event && <EventDescPartner event={event} partnerId={partnerId} />}
      <Footer logoUrl={event?.logoUrl} isDarkMode={event?.darkMode === false ? "light-mode" : ""} />
    </div>
  );
};

export default EventTicketingPartner;
